import * as React from 'react';

export const LoadingOverlay = (props: any) => {
    if (!props.loading) return null;
    return (
        <div className="loading-container">
            <div className="spinner"></div>
            <p>{props.loadingText}</p>
        </div>
    );
};
